module.exports = "<div class=\"game-view game-view__quiz\">\n  <div class=\"container\">\n    <div class=\"content\">\n\n      <div class=\"questions-wrapper\">\n\n      </div>\n\n      <div class=\"quiz-waiting__loader\" style=\"display: none;\">\n        <img src=\"" + require("Images/icons/img_waiting.svg") + "\" alt=\"Loading...\"/>\n        <p class=\"loading-text\" data-localize=\"serious_game.quiz.waiting\"></p>\n      </div>\n\n      <div class=\"quiz-result-wrapper\" style=\"display: none;\">\n        <!--Generated-->\n      </div>\n\n    </div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/views/partials/game/quiz.html
// module id = 798
// module chunks = 2